import { render, staticRenderFns } from "./MyRelations.vue?vue&type=template&id=0951ff2a&scoped=true&"
import script from "./MyRelations.vue?vue&type=script&lang=ts&"
export * from "./MyRelations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0951ff2a",
  null
  
)

export default component.exports